module.exports = __webpack_public_path__ + "img/ricelog_pinicon_100.23ff9143.png";